import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

type TeamMember = {
  id: string;
  collectionId: string;
  ig_username: string;
  first_name: string;
  last_name: string;
  photo: string;
  has_used_redemption?: boolean;
  redemption_passed_at?: string;
};

export function useTeamMember(id: string | undefined): {
  data: TeamMember | undefined;
} {
  const { data } = useQuery({
    queryKey: ['team-member', id],
    queryFn: () => pb.collection('team_members').getOne<TeamMember>(id!),
    enabled: !!id,
    staleTime: 300_000,
  });
  return { data };
}
